import { nanoid } from 'nanoid';
import { getCookie } from '../helpers/cookies';
var DEFAULT_TRACING_COOKIE_NAME = 'WB-SESSION-ID';
export var tracingCookie = function tracingCookie(cookies) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TRACING_COOKIE_NAME;
  var tracingCookieValue = cookies.get(name);
  if (!tracingCookieValue) {
    var tracingId = nanoid();
    cookies.set(name, tracingId, {
      httpOnly: false,
      maxAge: 10 * 60 * 60 * 100
    });
    return tracingId;
  }
  return tracingCookieValue;
};
export var getDefaultSessionTracing = cookies => {
  return {
    [DEFAULT_TRACING_COOKIE_NAME]: tracingCookie(cookies)
  };
};
export var getClientDefaultSessionTracing = function getClientDefaultSessionTracing() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TRACING_COOKIE_NAME;
  return {
    [DEFAULT_TRACING_COOKIE_NAME]: getCookie(name)
  };
};